import PropTypes from 'prop-types';

import { providers as designProviders } from '@febos-io/design';

import { useCompanyClinicByIdEffect, useTranslation } from '../hooks';

export function Clinic(
  {
    companyId,
    clinicId,
  }
) {
  const { t, } = useTranslation();
  const { Loader, } = designProviders.useDesignContext();
  const {
    loading,
    element,
  } = useCompanyClinicByIdEffect(companyId, clinicId);
  return (
    <div className="d-flex flex-column justify-content-between flex-grow-1">
      <div className="row gx-2">
        {loading ? (
          <Loader />
        ) : (
          <>
            <p>
              {t('Identification Number')}
              :
              {element.identification}
            </p>
            <p>
              {t('Name')}
              :
              {element.name}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Clinic;

Clinic.propTypes = {
  companyId: PropTypes.elementType.isRequired,
  clinicId: PropTypes.elementType.isRequired,
};
